<script>
    import Dashboard from "./Dashboard.svelte";
</script>

<Dashboard onSite={true}></Dashboard>
